export default function genererCritereRechercheFactureAchat() {
  return {
    auto: null,
    agencesId: [],
    tiersId: [],
    etat: [],
    dates: {
      dateDebut: null,
      dateFin: null,
    },
  };
}
